import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:grid-cols-5 md:px-6">
        <div className="md:col-span-2">
          <SectionHeading
            eyebrow="常见问题"
            title="关于韩国漫画大全"
            desc="关于本站分类方式、收录标准与使用方式的常见疑问，这里都能找到答案。"
          />
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            还有疑问？联系我们
            <i className="ri-message-3-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">
                      {item.q}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 transition-transform duration-300 ${isOpen ? "rotate-45 bg-primary-100 text-primary-700" : "text-foreground-600"}`}>
                      <i className="ri-add-line text-lg" aria-hidden="true" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}